export function getiOSVersion() {
  return Number(/(iPhone|iPad) OS ([1-9]*)/g.exec(window.navigator.userAgent)?.[2]);
}

export function isiOS17() {
  return getiOSVersion() === 17;
}
